<template>
  <div class="opera-orderDetail" :class="{overHide:popupVisible}">
    <topNav :title="$t('orderDetail_title')" url="/opera/orderList"></topNav>
    <div class="warp" v-if="orderInfo.sta">
      <div class="orderSta clearfix">
        <div class="Num">{{ $t('orderDetail_crsNo') }}:
          <span>{{ orderInfo.crsNo == "" ? orderInfo.accnt : orderInfo.crsNo }}</span>
        </div>
        <div class="sta">{{ $t('orderDetail_sta') }}:
          <span>{{ orderInfo.sta }}</span>
        </div>
      </div>
      <div class="infoList">
        <div class="info">
          <div class="infoTop">
            <i class="iconfont icon-changfangxingbiaoqian"></i>
            {{ $t('orderDetail_checkIn_info') }}
          </div>
          <ul class="infoContent twocol">
            <li>{{ $t('orderDetail_rsvArrDate') }}:
              <span class="infoVal">{{ orderInfo.arr | dateF }}</span>
            </li>
            <li>{{ $t('orderDetail_rsvDepDate') }}:
              <span class="infoVal">{{ orderInfo.dep | dateF }}</span>
            </li>
            <li>{{ $t('orderDetail_rmtypes') }}:
              <span
                class="infoVal">{{ orderInfo.rmtype }}*{{ orderInfo.rmnum }}{{ $t('orderDetail_rmtypes_unit') }}</span>
            </li>
            <li>{{ $t('fangT_rmno') }}:
              <span class="infoVal">{{ orderInfo.rmno }}
                  <i class="iconfont icon-xia" @click="gearRoom()"
                     v-if="orderInfo.rmno && orderInfo.rmnum==1 && orderInfo.sta=='R' && !onlyView"></i>
              </span>
            </li>
            <template v-if="!onlyView">
              <li class="p100" v-if="!orderInfo.rmno && orderInfo.rmnum==1 && orderInfo.sta=='R'">
                <div class="paiF" @click="gearRoom()">{{ $t('orderDetail_paiF') }}</div>
              </li>
              <li class=" p100" v-if="orderInfo.rmnum==1 && orderInfo.rmno && orderInfo.sta=='R'">
                <div class="ruZ" @click="roomCheckIn()">{{ $t('fangT_walkBook') }}</div>
              </li>
              <li class=" p100" v-if=" orderInfo.sta=='I'">
                <div class="ruZ" @click="checkoutVisible = true">{{ $t('fangTXQ_checkOut') }}</div>
              </li>
            </template>
          </ul>

          <div class="totalmoney">
            {{ $t('orderDetail_bookInfo') }}:
            <span>
                            <small>￥</small>{{ orderInfo.totalRoomRate }}</span>
          </div>
        </div>
        <div class="info ">
          <div class="infoTop">
            <i class="iconfont icon-changfangxingbiaoqian"></i>
            {{ $t('meetingDetail_orderInfo') }}
          </div>
          <ul class="infoContent twocol">
            <li>{{ $t('orderDetail_bookName') }}:
              <span class="infoVal">{{ orderInfo.rsvMan }}</span>
            </li>
            <li>{{ $t('sex') }}:
              <span class="infoVal">
                {{ orderInfo.sex == 1 ? $t('sexMale') : (orderInfo.sex == 2 ? $t('sexFemale') : "") }}</span>
            </li>

            <li>{{ $t('orderDetail_idNo') }}:
              <span class="infoVal">{{ orderInfo.idNo }}</span>
            </li>
            <li>{{ $t('book_idCode') }}:
              <span class="infoVal">{{ orderInfo.idType }}</span>
            </li>

            <li>{{ $t('orderDetail_mobile') }}:
              <span class="infoVal">
                  <a :href='"tel:"+orderInfo.mobile'>{{ orderInfo.mobile }}</a>
              </span>
            </li>
            <li>email:
              <span class="infoVal">
                  {{ orderInfo.email }}
              </span>
            </li>
            <li>{{ $t('orderDetail_memberNo') }}:
              <span class="infoVal">{{ orderInfo.cardNo }}</span>
            </li>
            <li class="p100">{{ $t('memberDetail_companyName') }}:
              <span class="infoVal">{{ orderInfo.mfCompanyName }}</span>
            </li>
            <li class="p100">{{ $t('book_active5') }}:
              <span class="infoVal">{{ orderInfo.mfTravelName }}</span>
            </li>
            <li class="p100">{{ $t('book_active4') }}:
              <span class="infoVal">{{ orderInfo.mfSourceName }}</span>
            </li>
          </ul>
        </div>
        <div class="info">
          <div class="infoTop">
            <i class="iconfont icon-changfangxingbiaoqian"></i>
            {{ $t('fangTXQ_market_sales') }}
          </div>
          <ul class="infoContent twocol">

            <li>{{ $t('cateringDetail_marketDes') }}:
              <span class="infoVal">{{ orderInfo.market }}</span>
            </li>
            <li>{{ $t('cateringDetail_sourceDes') }}:
              <span class="infoVal">{{ orderInfo.src }}</span>
            </li>
            <li>{{ $t('memberDetail_rateCode') }}:
              <span class="infoVal">{{ orderInfo.rateCode }}</span>
            </li>
            <li>{{ $t('book_channel') }}:
              <span class="infoVal">{{ orderInfo.channel }}</span>
            </li>
            <li>{{ $t('fangTXQ_crsNo') }}:
              <span class="infoVal">{{ orderInfo.crsNo }}</span>
            </li>
          </ul>
        </div>

        <div class="info" style="padding-top:2000;" id="sss">
          <div class="infoTop">
            <i class="iconfont icon-changfangxingbiaoqian"></i>
            {{ $t('fangTXQ_other') }}
          </div>
          <ul class="infoContent">
            <li style="height:auto">{{ $t('fangTXQ_remark') }}:
              <span class="infoVal">{{ orderInfo.remark }}</span>
            </li>
            <li style="height:auto">{{ $t('fangTXQ_sepcials') }}:
              <span class="infoVal">{{ orderInfo.specials }}</span>
            </li>
            <li>{{ $t('fangTXQ_createUser') }}:
              <span class="infoVal">{{ orderInfo.createUser }}</span>
            </li>
            <li>{{ $t('fangTXQ_createDatetime') }}:
              <span class="infoVal">{{ orderInfo.createDatetime }}</span>
            </li>
            <li>{{ $t('fangTXQ_modifyUser') }}:
              <span class="infoVal">{{ orderInfo.modifyUser }}</span>
            </li>
            <li>{{ $t('fangTXQ_modifyDatetime') }}:
              <span class="infoVal">{{ orderInfo.modifiyDatetime }}</span>
            </li>
          </ul>
        </div>
      </div>
      <mt-palette-button content="+" direction="lt" class="pb" :radius="80" v-if="orderInfo.sta != 'O' && !onlyView" ref="target_1"
                         mainButtonStyle="color:#fff;background-color:#f6a624;" style="right:30px;">
        <div class="my-icon-button indexicon icon-popup" v-if="orderInfo.sta=='I'" @click="sub_log();feeVisible = true">
          <i class="iconfont icon-jia"></i>
        </div>
        <div class="my-icon-button indexicon icon-popup" v-if="orderInfo.sta=='R'" @click="sub_log();cancelOrder()">
          <i class="iconfont icon-cuowu"></i>
        </div>
      </mt-palette-button>
      <div class="bill">
        <div class="billtop">{{ $t('fangTXQ_bill') }}</div>
        <div class="billContent">
          <ul class="billList clearfix">
            <li>{{ $t('fangTXQ_masterBase') }}:
              <span>￥{{ orderInfo.balance }}</span>
            </li>
            <li>{{ $t('orderDetail_pay') }}:
              <span>￥{{ orderInfo.depositDue }}</span>
            </li>
            <li>{{ $t('book_payCode') }}:
              <span>{{ orderInfo.payCode }}</span>
            </li>
          </ul>
          <table class="itemsList" v-if="orderInfo.sta == 'I'">
            <tr class="category">
              <th width="60px">
                <span>{{ $t('couponUse_couponCode') }}</span>
              </th>
              <th width="108px">
                <span>{{ $t('fangTXQ_project') }}</span>
              </th>
              <th width="68px">
                <span>{{ $t('prderDetail_opera_num') }}</span>
              </th>
              <th width="1.3333rem">
                <span>{{ $t('fangTXQ_amount') }}</span>
              </th>
            </tr>
            <tr class="item" v-for="(val,key) in accountList" :key="key" v-if="val.isDisplay">
              <td>{{ val.taCode }}</td>
              <td>{{ val.description }}</td>
              <td>{{ val.folioNum }}</td>
              <td>{{ val.amount }}</td>
            </tr>
            <tr v-if="accountList.length == 0">
              <td colspan="4" style="text-align:center;color:#ccc;padding:0.2667rem">
                {{ $t('prderDetail_no_data') }}
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div class="dx">
        <span>{{ $t('loading_end_message') }}</span>
      </div>
    </div>
    <!-- 排房/入住 -->
    <mt-popup v-model="popupVisible" position="right" class="setroom" :modal="false">
      <div class="top">
        <i class="iconfont icon-zuo" @click="canclePop"></i>
        {{ $t('orderDetail_paiF') }} ({{ orderInfo.rmtype }} 1{{ $t('orderDetail_rmtypes_unit') }})
      </div>
      <div class="fil">
        <div class="fil-text">
          <label for="room">{{ $t('fangT_rmno') }}:</label>
          <input type="text" id="room" class="roomfil" v-model="filterRoomNum">
        </div>
        <div class="fil-radio">
          <div class="radio-box" v-for="item in rstatus.arr" :key="item.c">
            <input type="checkbox" :id="item.c" v-model="rstatus.checkVal" :value="item.c"/>
            <label :for="item.c">{{ item.n }}</label>
          </div>
        </div>
      </div>
      <div class="gearRoomList">
        <table style="height:40px;">
          <tr>
            <th width='16%'>
              {{ $t('orderDetail_pick_room') }}
            </th>
            <th width='28%'>
              {{ $t('fangQ_takeup') }}
            </th>
            <th width='28%'>
              {{ $t('fangTXQ_rmno') }}
            </th>
            <th width='28%'>
              {{ $t('orderDetail_sta') }}
            </th>
          </tr>
        </table>
        <div class="gear_table_list">
          <table>
            <tr v-for="item in filterGearRoomInfo" :key="item.rmno">
              <td width='16%'>
                <input type="radio" :id="item.rmno" v-model="roomChecked" :value="item.rmno"/>
                <label :for="item.rmno"></label>
              </td>
              <td width='28%'>
                {{ item.frontOfficeStatus == 'OCC' ? $t('fangQ_takeup') : $t('fangQ_orderDetail_free') }}
              </td>
              <td width='28%'>
                {{ item.rmno }}
              </td>
              <td width='28%'>
                {{ item.roomStatus | setRoomSta }}
              </td>
            </tr>
          </table>
        </div>

      </div>
      <div class="bottom">
        <div class="plan" @click='submitGear(0)'>{{ $t('orderDetail_paiF') }}</div>
      </div>
    </mt-popup>

    <mt-popup v-model="feeVisible" position="bottom" class="checkOutPop" :modal="true">
      <div class="top">
        <i class="iconfont icon-zuo" @click="feeVisible=false"></i>
        {{ $t('AccountIn_title') }}
      </div>
      <div class="checkoutinfoPop">

        <div class="checkList">
          <switchbtn checked='swith' @change="switchChange" :title1="$t('accountCode_pay')"
                     :title2="$t('accountCode_fee')"></switchbtn>
        </div>
        <div class="checkList">
          <label>{{ $t('prderDetail_opera_fee_type') }} :</label>
          <select v-model="postCharge.taCode" v-if="feeisPay">
            <option v-for="item in payCode" :value="item.code" :key="item.code">{{ item.name }}
            </option>
          </select>
          <select v-model="postCharge.taCode" v-else>
            <option v-for="item in feeCode" :value="item.code" :key="item.code">{{ item.name }}
            </option>
          </select>
        </div>
        <div class="checkList">
          <label>{{ $t('fangTXQ_amount') }} :</label> <input type="text" v-model="postCharge.money"></div>
        <div class="checkList">
          <label>{{ $t('remark') }} :</label> <input type="text" v-model="postCharge.remark"></div>
        <div class="tip">
          <i class="iconfont icon-gantan"></i>
          {{ $t('prderDetail_opera_notice') }}
        </div>
      </div>

      <div class="popBottom">
        <div class="cCancle" @click='feeVisible=false'>{{ $t('cancel') }}</div>
        <div class="cSure" @click='PostFee'>{{ $t('determine') }}</div>
      </div>
    </mt-popup>
    <mt-popup v-model="checkoutVisible" position="bottom" class="checkOutPop" :modal="true">
      <div class="top">
        <i class="iconfont icon-zuo" @click="checkoutVisible=false"></i>
        {{ $t('fangTXQ_checkOut') }}
      </div>
      <div class="checkoutinfoPop">
        <div class="checkList">
          <label>{{ $t('fangTXQ_needMoney') }} :</label> <input type="text" v-model="checkOutInfo.pay"
                                                                readonly="readonly"></div>
        <div class="checkList">
          <label>{{ $t('fangTXQ_needMoney2') }} :</label> <input type="text" v-model="checkOutInfo.pay"
                                                                 readonly="readonly"></div>
        <div class="checkList">
          <label>{{ $t('fangTXQ_checkMethod') }} :</label>
          <select v-model="checkOutInfo.ta">
            <option v-for="item in payCode" :value="item.code" :key="item.code">{{ item.name }}
            </option>
          </select>
        </div>
        <div class="checkList">
          <label>{{ $t('remark') }} :</label> <input type="text" v-model="checkOutInfo.remark"></div>
      </div>

      <div class="popBottom">
        <div class="cCancle" @click='checkoutVisible=false'>{{ $t('cancel') }}</div>
        <div class="cSure" @click='roomCheckOut'>{{ $t('determine') }}</div>
      </div>
    </mt-popup>
    <mt-popup v-model="guestPopVisible" v-if="updateGuest" class='guestInfo' popup-transition="popup-fade">
      <h2>{{ $t('orderDetail_guest_info') }}</h2>

      <div class="guestSwiper">
        <p>{{ $t('fangT_rmno') }}：
          <span class="formRoomNum"> {{ orderInfo.rmno }}</span>
        </p>
        <div class="infoToWrite">
          <mt-field :label="$t('orderDetail_guest_name')" :placeholder="$t('orderDetail_guest_name_placeholder')"
                    v-model='orderInfo.rsvMan'></mt-field>
          <mt-field :label="$t('memberSearch_searchType_idNo')" :placeholder="$('fangTXQ_idNo_placeholder')"
                    v-model='orderInfo.idNo'></mt-field>
        </div>
      </div>

      <div class="btn">
        <div class="unSure" @click="cancleGuestPop">{{ $t('cancel') }}</div>
        <div class="sure" @click="changGuest">{{ $t('determine') }}</div>
      </div>
    </mt-popup>
    <mt-popup v-model="popupEvalDay" position="bottom" class="everyDatePop" :modal="true">
      <table class="checkList" align='center' style="border-collapse:collapse;">
        <tbody>
        <tr>
          <th width="40%">{{ $t('fangTXQ_date') }}</th>
          <th width="30%">{{ $t('fangTXQ_rate') }}</th>
          <th width="30%">{{ $t('fangTXQ_rmnum') }}</th>
        </tr>
        </tbody>
        <tr>
          <td>{{ $t('fangTXQ_total') }}</td>
          <td>{{ sumRate(dateRate) }}</td>
          <td></td>
        </tr>
        <tr v-for="item in dateRate" :key="item.rsv_date">
          <td>{{ item.rsv_date | dateF }}</td>
          <td>
            <small>￥</small>
            {{ item.realShareRate }}
          </td>
          <td>{{ item.rmnum }}</td>
        </tr>
      </table>
    </mt-popup>
  </div>
</template>

<script>
import _ from "lodash";
import {Swipe, SwipeItem, Toast, MessageBox} from "mint-ui";
import moment from 'moment'
import switchbtn from '../operaCommon/switch'

export default {
  data() {
    return {
      // checkedNames:[],
      roomChecked: "",
      orderInfo: {}, //订单详细
      popupVisible: false,
      gearRoomInfo: [], //排房前信息
      selectedroom: [],
      confineRoom: [{rmnum: "1", type: ""}],
      gearOption: {
        //排房请求信息
        InDatas: [],
        rowDatas: []
      },
      checkOutInfo: {
        ta: "",
        id: "",
        pay: 0,
        remark: ""
      },
      guestPopVisible: false,
      guestInfoCache: {},
      dateRate: [],
      updateGuest: null,
      popupEvalDay: false,
      checkoutVisible: false,
      feeVisible: false,
      feeisPay: true,
      postCharge: {
        id: "",
        taCode: "",
        money: null,
        remark: ""
      },
      bizDate: "",
      feeCode: [],//费用
      payCode: [],//付款
      accountList: null,
      //过滤条件
      rstatus: {
        arr: [{c: "PU", n: this.$t('fangT_RoomStaPU')},
          {c: "CL", n: this.$t('fangT_RoomStaR')},
          {c: "DI", n: this.$t('fangT_RoomStaD')},
          {c: "IP", n: this.$t('fangT_RoomStaI')},
          {c: "OO", n: this.$t('fangT_RoomStaOOO')},
          {c: "OS", n: this.$t('fangT_RoomStaOOS')}],
        checkVal: ['IP']
      },
      filterRoomNum: '',
      onlyView: false, // 环球的订单只能看，不能操作
    };
  },
  computed: {
    filterGearRoomInfo() {
      let arr = this.gearRoomInfo.filter(item => {
        //console.log(this.rstatus.checkVal);
        //console.log(item.roomStatus);
        return item.rmno.indexOf(this.filterRoomNum) >= 0 && this.rstatus.checkVal.indexOf(item.roomStatus) >= 0
      })
      //console.log(arr)
      return arr
    }
  },
  mounted() {
    this.onlyView = this.$route.query.viewType == 'HuanQiu'
    this.getOrderDetail();
  },
  methods: {
    /*获取基本订单详情*/
    getOrderDetail() {
      this.$http
        .post(
          "/mobilepmsapi/opera/biz/getOrderDetail?rsvNo=" +
          this.$route.query.rsvNo
        )
        .then(res => {
          if (res.data.result == 0) {
            this.orderInfo = res.data.retVal.dto;
            this.bizDate = res.data.retVal.bizDate;
            this.payCode = res.data.retVal.payCode;
            this.feeCode = res.data.retVal.feeCode;
            this.checkOutInfo.pay = this.orderInfo.balance;
            this.accountList = res.data.retVal.accountList;
            if (this.payCode.length > 0) {
              this.checkOutInfo.ta = this.payCode[0].code;
            }
            if (this.payCode.length > 0) {
              this.postCharge.taCode = this.payCode[0].code;
            }
          } else {
            this.msg(res.data.msg);
          }
        });
    },
    switchChange(value) {
      this.feeisPay = value;
      if (value) {
        if (this.payCode.length > 0) {
          this.postCharge.taCode = this.payCode[0].code;
        }
      } else {
        if (this.feeCode.length > 0) {
          this.postCharge.taCode = this.feeCode[0].code;
        }
      }
    },
    getEveryDateRate(mb) {
      this.popupEvalDay = true;
      this.$http
        .post("/mobilepmsapi/reception/getEveryDateRate", {
          masterId: mb.id,
          arr: mb.arr,
          dep: mb.dep
        })
        .then(res => {
          this.dateRate = res.data.retVal;
        });
    },
    sumRate(value) {
      var sum = 0;
      for (var i = 0; i < this.dateRate.length; i++) {
        sum += this.dateRate[i].realShareRate * this.dateRate[i].rmnum;
      }
      return sum;
    },
    /*获取排房前信息*/
    gearRoom() {
      this.selectedroom = [];
      this.confineRoom = [{rmnum: "1", type: ""}];
      this.gearOption.InDatas = [];
      this.gearOption.rowDatas = [];
      this.$http
        .post(
          "/mobilepmsapi/opera/biz/getRoomAvail?rmtype=" +
          this.orderInfo.rmtype +
          "&start=" +
          this.orderInfo.arr +
          "&end=" +
          this.orderInfo.dep,
          {}
        )
        .then(res => {
          if (res.data.result == 0) {
            // console.log(res.data)
            this.gearRoomInfo = res.data.retVal;
            // console.log(this.gearRoomInfo)
            this.popupVisible = true;
          }
        });
    },
    roomCheckOut() {
      MessageBox.confirm(this.$t('operaOrderDetail_sure_checkout'))
        .then(action => {
          this.checkOutInfo.id = this.orderInfo.accnt;
          this.$http
            .post("/mobilepmsapi/opera/biz/checkout", this.checkOutInfo)
            .then(res => {
              if (res.data.result == 0) {
                this.checkoutVisible = false;
                this.getOrderDetail();
              } else {
                this.getOrderDetail();
                this.msg(res.data.msg);
              }
            });
        })
        .catch(action => {
        });
    },
    PostFee() {
      if (this.postCharge.money == null || this.postCharge.money <= 0) {
        this.msg(this.$t('operaOrderDetail_sure_money'));
        return;
      }
      MessageBox.confirm(this.$t('operaOrderDetail_sure_account_in'))
        .then(action => {
          this.postCharge.id = this.orderInfo.accnt;
          this.$http
            .post("/mobilepmsapi/opera/biz/postCharge", this.postCharge)
            .then(res => {
              if (res.data.result == 0) {
                this.postCharge.money = null;
                this.feeVisible = false;
                this.getOrderDetail();
              } else {
                this.msg(res.data.msg);
              }
            });
        })
        .catch(action => {
        });
    },
    roomCheckIn() {
      if (moment(this.orderInfo.arr.substring(0, 10)) > moment(this.bizDate)) {
        this.msg(this.$t('operaOrderDetail_sure_not_end'));
        return;
      }
      MessageBox.confirm(this.$t('operaOrderDetail_sure_checkIn'))
        .then(action => {
          this.$http
            .post("/mobilepmsapi/opera/biz/checkIn?id=" + this.orderInfo.accnt, {})
            .then(res => {
              if (res.data.result == 0) {
                this.getOrderDetail();
              } else {
                this.msg(res.data.msg);
              }
            });
        })
        .catch(action => {
        });
    },
    sub_log() {
      this.$refs.target_1.collapse();
    },

    /*选中的房间*/
    selectRoom(value) {
      if (this.selectedroom.indexOf(value) != -1) {
        this.selectedroom.splice(this.selectedroom.indexOf(value), 1);
      } else if (this.selectedroom.length < this.gearRoomInfo.rmnum) {
        this.selectedroom.push(value);
      }
    },
    vShowDelete(n) {
      var data = this.confineRoom[n];
      if (data.type == "rowDatas") {
        for (var i = 0; i < this.gearOption.rowDatas.length; i++) {
          if (this.gearOption.rowDatas[i] == data.rmnum) {
            this.gearOption.rowDatas.splice(i, 1);
            break;
          }
        }
      } else if (data.type == "InDatas") {
        for (var i = 0; i < this.gearOption.InDatas.length; i++) {
          if (this.gearOption.InDatas[i] == data.rmnum) {
            this.gearOption.InDatas.splice(i, 1);
            break;
          }
        }
      }
      this.confineRoom.splice(n, 1);
    },
    cancelOrder() {
      MessageBox.prompt(this.$t('operaOrderDetail_sure_cancel_reason'))
        .then(({value, action}) => {
          this.$http
            .post("/mobilepmsapi/opera/biz/cancelOrder ", {
              id: this.$route.query.rsvNo,
              reason: value
            })
            .then(res => {
              if (res.data.result == 0) {
                this.msg(this.$t('msg_cancel_success'));
                this.getOrderDetail();
              } else {
                this.msg(res.data.msg);
              }
            });
        })
        .catch(action => {
        });
    },
    /*选中的房间选择排房、入住*/
    pushSelected(value) {
      for (var i = 0; i < this.confineRoom.length; i++) {
        for (var n = 0; n < this.selectedroom.length; n++) {
          if (this.confineRoom[i].rmnum == this.selectedroom[n]) {
            this.msg(this.$t('operaOrderDetail_room') + this.selectedroom[n] + this.$t('operaOrderDetail_room_choose'));
            return;
          }
        }
      }

      if (this.selectedroom.length > 0) {
        if (
          this.gearOption.rowDatas.length +
          this.gearOption.InDatas.length +
          this.selectedroom.length >
          this.gearRoomInfo.rmnum
        ) {
          this.msg(this.$t('operaOrderDetail_room_over'));
          return;
        }
        if (value == 0) {
          //排房
          _.forEach(this.selectedroom, (el, key) => {
            this.confineRoom.push(_.merge({}, {rmnum: el, type: "rowDatas"}));
            this.gearOption.rowDatas.push(el);
          });
        } else if (value == 1) {
          //入住
          _.forEach(this.selectedroom, (el, key) => {
            this.confineRoom.push(_.merge({}, {rmnum: el, type: "InDatas"}));
            this.gearOption.InDatas.push(el);
          });
        }
        this.selectedroom = [];
      } else {
        this.msg(this.$t('operaOrderDetail_room_no'));
      }
    },
    msg(msg) {
      Toast({
        message: msg,
        position: "bottom",
        duration: 3000
      });
    },
    /*提交排房/入住信息*/
    submitGear(value) {

      if (this.roomChecked == "") {
        this.msg(this.$t('operaOrderDetail_room_special'))
        return
      }
      let reqObj = {
        rsvId: this.orderInfo.accnt,
        rowDatas: [this.roomChecked],
        rsvNo: "",
        masterId: 0,
      }
      MessageBox.confirm(this.$t('operaOrderDetail_room_confirm1') + `【${this.roomChecked}】` + this.$t('operaOrderDetail_room_confirm2'))
        .then(action => {
          this.$http
            .post("/mobilepmsapi/opera/biz/finishRowHouse", reqObj)
            .then(res => {
              if (res.data.result == 0) {
                this.popupVisible = false;
                this.roomChecked = ""
                this.getOrderDetail();
              } else {
                this.msg(res.data.msg);

              }
              console.log(res.data);
            });
        })
        .catch(action => {
        });
    },
    /*关闭排房界面返回详情页*/
    canclePop() {
      this.popupVisible = false;
      this.roomChecked = ""
      this.selectedroom = [];
      // his.rstatus.checkVal=['IP']
      //  this.filterRoomNum=''
    },

    /*添加入住人信息*/
    addGuest(link) {
      this.updateGuest = link;
      this.guestPopVisible = true;
    },
    /*改变入住人信息*/
    changGuest() {
      this.guestPopVisible = false;
      let guestinfo = [];

      guestinfo.push({
        id: this.updateGuest.masterBase.id,
        name: this.updateGuest.masterGuest.name,
        idNo: this.updateGuest.masterGuest.idNo
      });
      console.log(guestinfo);
      this.$http
        .post("/mobilepmsapi/reception/updateMasterGuest", guestinfo)
        .then(res => {
          if (res.data.result == 0) {
            this.msg(this.$t('msg_modify_success'));
            this.guestPopVisible = false;
          } else {
            this.msg(res.data.msg);
          }
        });
    },
    /*关闭入住人信息弹框*/
    cancleGuestPop() {
      this.guestPopVisible = false;
      this.getOrderDetail();
    }
  },
  filters: {
    dateF(value) {
      return value != null ? value.replace(/-/g, "/").substring(5, 10) : "";
    },
    dateD(value) {
      return value != null ? value.replace(/-/g, "/").substring(5, 16) : "";
    },
    showConfine(value) {
      return !!value == true ? value.rmnum : "";
    },
    setRoomSta(v) {
      if (v == "PU") return this.$t('fangT_RoomStaPU');
      else if (v == "CL") return this.$t('fangT_RoomStaR');
      else if (v == "DI") return this.$t('fangT_RoomStaD');
      else if (v == "IP") return this.$t('fangT_RoomStaI');
      else if (v == "OO") return this.$t('fangT_RoomStaOOO');
      else if (v == "OS") return this.$t('fangT_RoomStaOOS');
      else return v;
    }
  },

  components: {switchbtn}
};
</script>
<style lang='less'>
.opera-orderDetail {
  background: #f7f8fa;

  &.overHide {
    overflow: hidden;
  }

  .warp {
    margin: 10px auto;
    background: #f6f8f9;

    .orderSta {
      background-color: #f6f8f9;
      height: 32px;
      line-height: 26px;
      color: #333;

      .Num {
        float: left;
        margin-left: 8px;
      }

      .sta {
        float: right;
        margin-right: 8px;

        span {
          color: #ffffff;
          font-weight: bold;
          font-size: 16px;
          border-radius: 12px;
          display: inline-block;
          width: 22px;
          height: 22px;
          text-align: center;
          background: #646f83;
          vertical-align: middle;
          line-height: 22px;
        }
      }
    }

    .infoList {
      margin: 0 10px;
      background: #fff;
      box-shadow: 0 -2px 20px rgba(0, 0, 0, 0.15);
      border-radius: 4px;

      .info {
        padding: 10px 0;

        .infoTop {
          padding: 0 18px;
          position: relative;
          height: 20px;
          line-height: 20px;

          .icon-changfangxingbiaoqian {
            position: absolute;
            font-size: 12px;
            left: 0;
            top: 1px;
            color: #f6a624;
          }
        }

        .infoContent {
          margin: 0 20px;
          padding: 10px 0;
          border-bottom: 1px dashed #ddd;
          clear: both;

          .mintui-more {
            color: #aaa;
            font-size: 12px;
            margin-left: 10px;
          }

          .p100 {
            clear: both;
            width: 100% !important;
          }

          li {
            margin: 2px auto;
            line-height: 20px;

            .infoVal {
              margin-left: 8px;
            }

            .addGuest {
              float: right;
              background-color: #f6a624;
              border-radius: 50%;
              width: 20px;
              height: 20px;
              text-align: center;

              .iconfont {
                color: #fff;
                font-size: 12px;
                line-height: 20px;
              }
            }

            .paiF {
              height: 32px;
              width: 70px;
              margin-left: 3rem;
              text-align: center;
              float: right;
              line-height: 32px;
              background-color: #f4f4f4;
              border: 1px solid #ddd;
              border-radius: 4px;
            }

            .ruZ {
              background-color: #f6a624;
              color: #fff;
              height: 32px;
              float: right;
              width: 70px;
              text-align: center;
              line-height: 32px;
              border: 1px solid #ddd;
              border-radius: 4px;
            }
          }

          &.twocol {
            overflow: hidden;

            li {
              width: 50%;
              float: left;
            }
          }
        }

        .totalmoney {
          margin: 0 20px;
          height: 30px;
          line-height: 30px; //border-bottom: 1px dashed #ddd;
          span {
            margin-left: 0;
          }
        }
      }
    }
  }

  .setroom {
    /*position: fixed;
top:0;
    left: 0;*/
    z-index: 101 !important;
    height: 100%;
    width: 100%;
    background-color: #fff;

    .infoTitle {
      height: 1.3333rem;
      text-align: center;
      font-size: 14px;
      line-height: 1.3333rem;
    }

    .fil {
      margin: 0.2667rem 30px 0.2667rem;
      display: inline-block;

      .fil-text {
        float: left;
        width: 25%;
        height: 1.3333rem;

        label {
          line-height: 0.6667rem;
        }

        input {
          width: 100%;
          line-height: 0.5333rem;
          border: 1px solid #eee;
        }
      }

      .fil-radio {
        width: 75%;
        float: right;

        .radio-box {
          width: 30%;
          float: right;
          height: 25px;
          line-height: 25px;

          input[type="checkbox"] + label::before {
            content: "\a0"; /*不换行空格*/
            display: inline-block;
            vertical-align: .2em;
            width: 1em;
            height: 1em;
            margin-right: .2em;
            border-radius: .2em;
            // background-color: silver;
            text-indent: .15em;
            line-height: .65; /*行高不加单位，子元素将继承数字乘以自身字体尺寸而非父元素行高*/
            border: 1px solid #eee;
          }

          input[type="checkbox"]:checked + label::before {
            content: "\2713";
            background-color: #f69c2d;
          }

          input[type="checkbox"] {
            position: absolute;
            clip: rect(0, 0, 0, 0);
          }
        }
      }
    }

    .top {
      line-height: 40px;
      font-size: 16px;
      text-align: center;
      padding: 0 15px;
      height: 40px;
      background: #393c41;
      color: #fff;
      text-align: center;
      border-bottom: 1px solid #eee;

      .iconfont {
        line-height: 40px;
        font-size: 16px;
        float: left;
      }

      .sureGear {
        float: right;
      }
    }

    .optional {
      padding: 0.2667rem 12px;

      .option {
        margin: 0.125rem;
        height: 1rem;
        width: 2rem;
        float: left;
        border: 1px solid #aaa;
        border-radius: 2px;
        text-align: center;
        font-size: 0.37rem;
        line-height: 1rem;
        color: #999;
        position: relative;
        background-color: #fff;

        &.choose {
          background-color: #d3d3d3;
        }

        .cleartext {
          position: absolute;
          right: -0.15rem;
          bottom: -0.28rem;
          display: block;

          i.icon-cuowu {
            line-height: 0.32rem;
            background-color: #c3c3c3;
            border-radius: 50%;
            font-size: 0.32rem;
            text-align: center;
            color: #fff;
            padding: 0.13333333rem;
            margin-top: 0.13333333rem;
            -webkit-transform-origin-x: 0;
            transform: scale(0.6);
            -webkit-transform: scale(0.6);
            width: 0.32rem;
            display: inline-block;
          }
        }
      }

      &.selected {
        .option {
          border: 1px dashed #aaa;

          &.InDatas {
            background-color: #428fc8;
            color: #fff;
          }

          &.rowDatas {
            background-color: #00c05a;
            color: #fff;
          }
        }
      }
    }

    .gearRoomList {
      table {
        width: 100%;
        text-align: center;

        th {
          background: #f69c2d;
          color: #fff;
          height: 24px;
          font-size: 14px;
        }
      }

      .gear_table_list {
        height: ~"calc(100vh - 4.5rem)";
        overflow-y: scroll;
        padding-bottom: 1.0667rem;

        table {
          tr {
            td {
              height: 30px;
              background: #eee;

              input[type="radio"] + label::before {
                content: "\a0";
                /*不换行空格*/
                display: inline-block;
                vertical-align: middle;
                font-size: 0.32rem;
                width: 0.3rem;
                height: 0.3rem;
                margin-right: .4em;
                border-radius: 50%;
                border: 1px solid #f69c2d;
                text-indent: .1em;
                line-height: 1;
              }

              input[type="radio"]:checked + label::before {
                background-color: #f69c2d;
                background-clip: content-box;
                padding: .1em;
              }

              input[type="radio"] {
                position: absolute;
                clip: rect(0, 0, 0, 0);
              }
            }

            &:nth-child(2n) {
              td {
                background: #f5f5f5;
              }
            }
          }
        }
      }
    }

    .bottom {
      position: absolute;
      bottom: 0;
      width: 100%;

      .plan {
        float: left;
        height: 1.3333rem;
        line-height: 1.3333rem;
        width: 100%;
        background: #f69c2d;
        color: #fff;
        font-size: 18px;
        text-align: center;
        border-right: 1px solid #fff;
        box-sizing: border-box;
      }

      .checkIn {
        box-sizing: border-box;
        border-left: 1px solid #fff;
        float: left;
        height: 1.3333rem;
        line-height: 1.3333rem;
        width: 50%;
        background: #428fc8;
        color: #fff;
        font-size: 16px;
        text-align: center;
      }
    }
  }

  .guestInfo {
    width: 90%;
    height: 330px;
    position: absolute;
    margin: 0 auto;
    background-color: #fff;
    border-radius: 0.2667rem;

    h2 {
      font-size: 18px;
      color: #666666;
      text-align: center;
      font-style: normal;
      padding: 0.2667rem 0;
    }

    .mint-cell-title {
      width: 80px;
    }

    .guestSwiper {
      padding: 0 4%;

      p {
        font-size: 18px;
        color: #57b658;
        padding: 20px 0 20px 5px;
      }
    }

    .btn {
      height: 55px;
      border-top: 1px solid #bdbdbd;
      text-align: center;
      font-size: 16px;
      position: absolute;
      bottom: 0;
      width: 100%;

      .unSure {
        border-right: 1px solid #bdbdbd;
        width: 50%;
        box-sizing: border-box;
        float: left;
        line-height: 55px;
      }

      .sure {
        width: 50%;
        box-sizing: border-box;
        float: left;
        line-height: 55px;
        color: #5190c3;
      }
    }
  }

  .everyDatePop {
    width: 100%;
    height: 50%;
    overflow-y: scroll;

    .checkList {
      width: 100%;

      tr {
        background-color: #fff;

        &:nth-of-type(2n) {
          background-color: #f5f5f5;
        }

        font-size: 0.32rem;

        th {
          color: #fff;
          height: 1.06666667rem;
          text-align: center;
          font-size: 0.34666667rem;
          background-color: #f69c2c;
          padding: 0;
        }

        td {
          height: 1.06666667rem;
          padding: 0px;
          text-align: center;
        }
      }
    }
  }

  .pb {
    width: 60px;
    height: 60px;
    line-height: 60px;
    color: #fff;
    position: absolute;
    bottom: 30px;
  }

  .my-icon-button {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background-color: #f6a624;
    color: #fff;
    line-height: 30px;
    text-align: center;
  }

  .mint-main-button {
    color: #000;
    background-color: #f6a624;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  .checkOutPop {
    width: 100%;
    height: 100%;
    background: #fff; // padding-bottom:35px;
    overflow-y: auto;
    overflow-x: hidden;
    position: fixed;
    bottom: 0;

    .checkoutinfoPop {
      margin-top: 0.8rem;

      .tip {
        color: #999;
        float: right;
        font-size: 0.32rem;
        margin-right: 0.3rem;
        margin-top: .5rem;
      }
    }

    .top {
      line-height: 40px;
      font-size: 16px;
      text-align: center;
      padding: 0 15px;
      height: 40px;
      background: #393c41;
      color: #fff;
      text-align: center;
      border-bottom: 1px solid #eee;

      .iconfont {
        line-height: 40px;
        font-size: 16px;
        float: left;
      }

      .sureGear {
        float: right;
      }
    }

    .checkList {
      width: 100%;
      height: 40px;
      padding: 5px 0.2667rem;
      text-align: left;
      line-height: 40px;
      font-size: 14px;
      position: relative;

      label {
        height: 40px;
        line-height: 40px;
        width: 80px;
        float: left;
      }

      input {
        box-sizing: border-box;
        padding: 2px 5px;
        float: left;
        height: 30px;
        margin-top: 5px;
        line-height: 25px;
        width: 6rem;
        border-radius: 4px;
      }

      select {
        border: solid 1px #000;
        appearance: none;
        -moz-appearance: none;
        -webkit-appearance: none;
        padding-right: 14px;
        box-sizing: border-box;
        padding: 2px 5px;
        float: left;
        height: 30px;
        margin-top: 5px;
        line-height: 25px;
        width: 6rem;
        border-radius: 4px;
        background-image: linear-gradient(0deg, #e1e1e1 0%, #f9f9f9 98%);
      }

      select::-ms-expand {
        display: none;
      }

      .iconfont {
        background-color: #686868;
        width: 30px;
        line-height: 30px;
        position: absolute;
        top: 11px;
        text-align: center;
        left: 30.2667rem;
        border-radius: 0 5px 5px 0;
        height: 28px;
      }
    }

    .popBottom {
      position: fixed;
      width: 100%;
      bottom: 0;
      left: 0;
      height: 45px;
      background-image: linear-gradient(-90deg, #ff6e61 0%, #f6a129 98%);

      .cCancle,
      .cSure {
        float: left;
        height: 100%;
        width: 50%;
        color: #fff;
        font-size: 16px;
        box-sizing: border-box;
        border-right: 2px solid #fff;
        text-align: center;
        line-height: 45px;
      }

      .cSrue {
        border-right: none;
      }
    }
  }

  .bill {
    box-shadow: 0 -2px 20px rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    margin: 0.2667rem;
    background-color: #fff;
    clear: both;

    .billtop {
      text-align: center;
      font-size: 12px;
      font-weight: 600;
      line-height: 40px;
      height: 40px;
      box-sizing: border-box;
      border-bottom: 1px dashed #ddd;
    }

    .billContent {
      padding: 0 0.2667rem 0.2667rem;

      .billList {
        padding: 18px 3px;

        li {
          float: left;
          width: 50%;
          box-sizing: border-box;
          height: 25px;
          line-height: 25px;
          font-size: 12px;

          span {
            margin-left: 5px;
          }
        }
      }

      .itemsList {
        width: 100%;

        .category {
          background-color: #a4a4a4;
          height: 39px;
          color: #fff;

          th {
            span {
              width: 100%;
              display: block;
              border-right: 1px solid rgba(255, 255, 255, 0.3);
            }
          }
        }

        .item {
          height: 41px;

          td {
            text-align: center;
          }

          .small {
            transform-origin: center;
            transform: scale(0.83);
          }

          &:nth-of-type(2n) {
            background-color: #f5f5f5;
          }
        }
      }
    }
  }

  .dx {
    padding-bottom: 60px;
    text-align: center;
    height: 20px;
    margin-top: 20px;
    line-height: 20px;
    color: #eee;

    span {
      color: #ddd;
    }
  }
}
</style>




// WEBPACK FOOTER //
// orderDetail.vue?2596691c